import { Box, CircularProgress } from '@mui/material'
import React, { useEffect } from 'react'
import Header from '../components/Header'
import Scheduler from '../components/scheduler'
import { useLocation } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'
import { getInterview } from 'services/api/modules/recruitment/scheduler'
import { getApplicantDetail } from 'services/api/modules/recruitment/job-application'

const InterviewScheduler = () => {
  const { state } = useLocation()
  const queryClient = useQueryClient()

  const isEdit = state.is_edit
  const candidate_id = state.candidate_id
  const interviewId = state.id
  const profile_type = state.profile_type
  const {
    data: interviewData,
    isLoading,
    isFetching,
  } = useQuery(['getInterview', interviewId], async () => {
    if (isEdit) {
      const { data } = await getInterview(interviewId)
      return data
    }
  })

  // to get email candidate for candidate that has not interview data
  const {
    isLoading: applicantDetailIsLoading,
    error: applicantDetailError,
    data: applicantDetailData,
  } = useQuery(
    ['getApplicantDetail', interviewId],
    async () => {
      const { data } = await getApplicantDetail(interviewId)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const candidateDetails = isEdit && interviewData?.relations.jobAdCandidate.relations.candidateable
  const candidateId = isEdit ? interviewData?.relations.jobAdCandidate.id : state.id
  const candidateName = isEdit ? candidateDetails?.name : state.applicant_name
  const candidateEmail = isEdit
    ? candidateDetails?.email
    : applicantDetailData?.email
    ? applicantDetailData?.email
    : state.email
  const candidateImage = isEdit ? candidateDetails?.profile_image_url : state.profile_picture

  useEffect(() => {
    queryClient.invalidateQueries('getInterview')
  }, [])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box position={'sticky'} top={0} zIndex={10}>
        <Header isEdit={isEdit} />
      </Box>
      {isLoading || isFetching ? (
        <Box
          sx={{
            backgroundColor: 'alternate.main',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress sx={{ color: 'white.main' }} />
        </Box>
      ) : (
        <Scheduler
          candidateId={candidateId}
          // TODO recheck candidate id
          candidate_id_for_edit_email={candidate_id}
          profile_type={profile_type}
          candidateName={candidateName}
          candidateEmail={candidateEmail}
          candidateImage={candidateImage}
          interviewData={interviewData}
          isEdit={isEdit}
        />
      )}
    </Box>
  )
}

export default InterviewScheduler
